import { useMutation } from '@apollo/client';
import { REMOVE_ACCOUNT } from '@mutations/removeAccount';
import { Mutation } from 'types/generatedSchemaTypes';
import { useUiStore } from 'stores/uiStore';

const useRemoveAccount = () => {
  const [removeAccount] = useMutation<Mutation>(REMOVE_ACCOUNT, {
    awaitRefetchQueries: true,
    onCompleted: () => {
      useUiStore.getState().setSheetModal('accountRemovalSuccess');
    },
    onError: () => useUiStore.getState().setSheetModal('accountRemovalFailed'),
  });
  return { removeAccount };
};

export default useRemoveAccount;
